import { injectReducers } from '../../store/reducers'
import AppLayout from '../../components/Layouts/AppLayout'
import { AsyncComponent } from '../../components/Layouts/RouterLayout'
import * as ROUTES from '../../constants/routes'

const getProductTypeContainer = store =>
  import(/* webpackChunkName: "ProductType" */ './reducers')
    .then(module => injectReducers(store, module.default))
    .then(() => import(/* webpackChunkName: "ProductType" */ './containers/ProductTypeContainer'))
    .then(module => module.default)

export default (store) => ([
  {
    layout: AppLayout,
    exact: true,
    path: [
      ROUTES.PRODUCT_TYPE_LIST_PATH,
    ],
    component: AsyncComponent(() => getProductTypeContainer(store))
  }
])
